import React from 'react';
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Box,
} from '@mui/material';
import { Obra, Usuario } from '../../types';
import { usePermisos } from '../../hooks/usePermisos';

interface ObraSelectorProps {
  obras: Obra[];
  obraSeleccionada: string;
  onChange: (obraId: string) => void;
  showAllOption?: boolean;
  usuario: Usuario | null;
  sx?: any;
}

const ObraSelector: React.FC<ObraSelectorProps> = ({
  obras,
  obraSeleccionada,
  onChange,
  showAllOption = true,
  usuario,
  sx
}) => {
  const { verificarPermisosObra } = usePermisos(usuario);

  // Filtrar las obras según los permisos del usuario
  const obrasPermitidas = obras.filter(obra => verificarPermisosObra(obra.id));

  // Determinar si mostrar "Todas las obras" basado en el rol y permisos
  const mostrarTodasOpcion = showAllOption && obrasPermitidas.length > 0;

  return (
    <Box sx={{ minWidth: 200, ...sx }}>
      <FormControl fullWidth size="small">
        <InputLabel>Seleccionar Obra</InputLabel>
        <Select
          value={obraSeleccionada}
          onChange={(e) => onChange(e.target.value as string)}
          label="Seleccionar Obra"
          sx={{
            '.MuiOutlinedInput-notchedOutline': {
              borderColor: 'grey.300',
            },
            '&:hover .MuiOutlinedInput-notchedOutline': {
              borderColor: 'grey.400',
            },
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
              borderColor: 'primary.main',
            }
          }}
        >
          {mostrarTodasOpcion && <MenuItem value="">Todas las obras</MenuItem>}
          {obrasPermitidas.map((obra) => (
            <MenuItem key={obra.id} value={obra.id}>
              {obra.nombre}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};

export default ObraSelector;